import React, { PureComponent } from 'react'
import PremieredVideoItem from './PremieredVideoItem'
import VideoItem from "./VideoItem"

import "./VideoCarousel.css"
import { GlobalContext } from '../../Context/GlobalContext';
import { validateExpirationDate } from '../../utils/handlePremiereDates';

export default class VideoCarousel extends PureComponent {
  static contextType = GlobalContext;
  constructor(props) {
    super(props)
    this.carousel = React.createRef()
    this.state = {
      loading: false,
      date: new Date()
    }
  }

  componentDidMount() {
    let {contents, videos, loadContent} = this.props
    if(!contents && !videos && loadContent) {
      this.setState({loading: true})
      loadContent().finally(() => {
        if(this.carousel.current) {
          this.setState({loading: false})
        }
      })
    }
  }
  
  clickButtonLeft = () => {
    if(!this.carousel.current) {
      return
    }
    if (this.carousel.current.scrollLeft === 0) {
      this.carousel.current.scroll({
        left:
          this.carousel.current.scrollWidth - this.carousel.current.clientWidth,
        top: 0,
        behavior: "smooth",
      });
    } else {
      this.carousel.current.scroll({
        left:
          this.carousel.current.scrollLeft -
          this.carousel.current.clientWidth / 2,
        top: 0,
        behavior: "smooth",
      });
    }
  }

  clickButtonRight = () => {
    if(!this.carousel.current) {
      return
    }
    if (
      this.carousel.current.scrollWidth ===
      this.carousel.current.scrollLeft + this.carousel.current.clientWidth
    ) {
      this.carousel.current.scroll({
        left: 0,
        top: 0,
        behavior: "smooth",
      });
    } else {
      this.carousel.current.scroll({
        left:
          this.carousel.current.scrollLeft +
          this.carousel.current.clientWidth / 2,
        top: 0,
        behavior: "smooth",
      });
    }
  }

  constructVideoItems = () => {

    let {
      videos,
      category,
      color,
      setFile
    } = this.props
    if(!videos) {
      return []
    }

    if(category === "recent") {
      videos = videos.slice(0, 12);
    }

    return videos.map((item) => {
      if(!item || !category) {
        return "";
      }
      let onClick, previewSpecial;
      let previewType = category;
      switch(category) {
        case "live":
          if(!item.type) {
            item.type = "live"
          }
          previewSpecial = true
          onClick = () => { setFile(item, [], "live") };
          break
        case "playlists":
          if(!item.type) {
            item.type = "playlist"
          }
          onClick = () => {
            if(item.videos) {
              setFile(item.videos[0], item.videos, "playlist");
            } else {
              setFile(item.name, [], "playlist-first");
            }
          }
          previewSpecial = true
          break
        default:
          if(!item.type) {
            item.type = "video"
          }
          onClick = () => {
            setFile(item, videos, "playlist");
          }
          break
      }
      if (validateExpirationDate(item?.premiereDate)) {
        return <PremieredVideoItem videoObj={item}/>
      }
      return <VideoItem key={item._id}
        item={item}
        onClick={onClick}
        category={previewType}
        color={color}
        previewSpecial={previewSpecial}/>
    })
  }

  render() {
    let {videos,
      contents,
      header,
      headerInsert,
      onClickHeader} = this.props

    if(!contents) {
      if(videos) {
        contents = this.constructVideoItems()
      } else {
        contents = []
      }
    };

    return (
      <div className={(contents.length > 0 || this.state.loading) ? "" : "d-none"}>
        <div className="flex-row">
          <div
            className="home-section-header"
            onClick={onClickHeader}
          >
            {header}
          </div>
          {headerInsert}
        </div>
        <div className={this.state.loading ? "mb-3 carouselLoader" : "d-none"}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <span>Loading Contents...</span>
        </div>
        <div className={(contents.length > 0) ? "home-row-wrapper" : "d-none"}>
          <div
            className={this.context.darkMode?"dark row-btn-left":"row-btn-left"}
            onClick={this.clickButtonLeft}
          >
            <i className={this.context.darkMode?"dark fas fa-chevron-left":"fas fa-chevron-left"}></i>
          </div>
          <div className=" mb-3 border-bottom home-page-row" ref={this.carousel}>
            {contents}
            <div className="col-3 mb-3" id={this.context.thumbnailSize} />
          </div>
          <div
            className={this.context.darkMode?"dark row-btn-right":"row-btn-right"}
            onClick={this.clickButtonRight}
          >
            <i className={this.context.darkMode?"dark fas fa-chevron-right":"fas fa-chevron-right"}></i>
          </div>
        </div>
      </div>
    )
  }
}
